import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChatService } from 'src/app/services/ChatService/chat.service';
import { Subscription } from 'rxjs';
import * as fromStore from '../../store';
import { Store } from '@ngrx/store';
import * as generalActions from '../../store/actions/general.action';
import { pluck } from 'rxjs/operators';
import { Parent } from '../../models/data-models';


const sectors = [
  { value: '61', text: 'Agriculture' },
  { value: '11', text: 'Banking' },
  { value: '29', text: 'Business Owner / Enterprenuer' },
  { value: '31', text: 'Civil Servant' },
  { value: '43', text: 'Construction' },
  { value: '48', text: 'Education' },
  { value: '65', text: 'Energy' },
  { value: '59', text: 'Financial Services' },
  { value: '60', text: 'FMCG' },
  { value: '46', text: 'Franchising' },
  { value: '44', text: 'Gambling' },
  { value: '69', text: 'General Commerce' },
  { value: '12', text: 'Government' },
  { value: '52', text: 'Healthcare' },
  { value: '50', text: 'Hospitality / Tourism' },
  { value: '14', text: 'Information Technology' },
  { value: '58', text: 'Insurance' },
  { value: '30', text: 'Legal Services' },
  { value: '51', text: 'Mass Media' },
  { value: '64', text: 'Mining & Quarying' },
  { value: '71', text: 'Non Governmental Organization(NGOs)' },
  { value: '35', text: 'Others' },
  { value: '49', text: 'Pharmaceuticals' },
  { value: '34', text: 'Principal / Head Teacher' },
  { value: '32', text: 'Public Servant' },
  { value: '68', text: 'Public Utilities' },
  { value: '47', text: 'Real Estate' },
  { value: '70', text: 'Religious Organization' },
  { value: '45', text: 'Retail Sales' },
  { value: '33', text: 'Teacher' },
  { value: '13', text: 'Telecommunications' },
  { value: '63', text: 'Tourism' },
  { value: '62', text: 'Transport & Logistics' },
  { value: '55', text: 'Waste Disposal' }
];

const months = [
  { value: '1', text: 'January' },
  { value: '2', text: 'February' },
  { value: '3', text: 'March' },
  { value: '4', text: 'April' },
  { value: '5', text: 'May' },
  { value: '6', text: 'June' },
  { value: '7', text: 'July' },
  { value: '8', text: 'August' },
  { value: '9', text: 'September' },
  { value: '10', text: 'October' },
  { value: '11', text: 'November' },
  { value: '12', text: 'December' }
];

const occupations = [
  { value: '1', text: 'Employed' },
  { value: '4', text: 'Employer' },
  { value: '2', text: 'Entrepreneur' },
  { value: '20', text: 'Retired' },
  { value: '5', text: 'Self Employed' },
  { value: '3', text: 'Student' },
  { value: '7', text: 'Unemployed' }
];

@Component({
  selector: 'app-work-form',
  templateUrl: './work-form.component.html',
  styleUrls: ['./work-form.component.css']
})
export class WorkFormComponent implements OnInit, OnDestroy {
  @Output() changeUpTheViewTwo = new EventEmitter<string>();
  parentWorkInfoForm: FormGroup;
  spinner = false;
  destroy: Subscription[] = [];
  guardianID: any = undefined;
  occupations = occupations;
  months = months;
  sectors = sectors;

  constructor(
    private fb: FormBuilder,
    private chatservice: ChatService,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.parentWorkInfoForm = this.fb.group({
      monthly_income: ['', Validators.required],
      occupation_id: ['', Validators.required],
      company_name: ['', Validators.required],
      address: ['', Validators.required],
      work_sector: ['', Validators.required],
    });

    // this.destroy[0] = this.store
    //   .select(fromStore.getCurrentParentInfo)
    //   .subscribe(val => {
    //     console.log({ val });
    //     const { guardian } = val as Parent;
    //     this.guardianID = guardian;
    //   });

    this.destroy[0] = this.store
      .select(fromStore.getParentState)
      .pipe(pluck('parent_info'))
      .subscribe(val => {
        const work_info = (val as Parent)?.work_info;
        if (!work_info) {
          return;
        }
        this.parentWorkInfoForm.patchValue({ ...work_info });
      });
  }

  submitThisForm(form: FormGroup) {
    // )
    this.spinner = true;
    const payload = { ...form.value };
    this.store.dispatch(
      new generalActions.updateParentWorkInformation(payload)
    );
    this.changeUpTheViewTwo.emit();
    // formToSubmit.guardian = this.guardianID;
    // this.chatservice.saveParentWorkInformation(formToSubmit).subscribe(
    //   val => {
    //     // console.log(val);
    //     const { employer, role, annual_salary } = val.data;
    //     const objToStore = { employer, role, annual_salary };
    //     // generalActions.updateParentWorkInformation()
    //     this.spinner = false;
    //   },
    //   err => console.log(err)
    // );
  }

  ngOnDestroy() {
    this.destroy.forEach(element => element.unsubscribe());
  }
}
